module.exports = __webpack_public_path__ + "img/y-combinator.bf52858a.svg";